import { SET_HOVER_LINE } from './actionTypes';

const initialState = {
	hoverLine: undefined
};

const reducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_HOVER_LINE:
			return { ...state, hoverLine: payload };
		default:
			return state;
	}
};

export default reducer;
